export default __webpack_public_path__ + "static/logo-202b6affdc81e134e7f7c8820baf8ebd.png";